import { Expose } from 'class-transformer';

import { SnModel } from '@lib/common/models';

export class SnLprReport extends SnModel {
  @Expose()
  public id: string;

  @Expose()
  public updatedTimestamp: string;

  @Expose()
  public createdTimestamp: string;

  @Expose()
  public reportFormat: string;

  @Expose()
  public status: string;

  @Expose()
  public params: string;

  @Expose()
  public report: string;

  @Expose()
  public completedAt: string;

  @Expose()
  public organization: string;

  @Expose()
  public requestor: string;

  constructor(data: any = {}) {
    super();
    this.fromJSON(data);
  }
}
